module.exports = __webpack_public_path__ + "static/media/handstretch.018c8377.png";